import { fetchWithResponse } from "../utils/EasyFetch";

export interface UserRoleResponse {
  username: string;
  roles: string[];
}

export const getUserRole = async (
  username: string,
  token: string
): Promise<string[]> => {
  const response = await fetchWithResponse<UserRoleResponse>(
    "GET",
    "/credentials/" + username,
    undefined,
    "Bearer " + token
  );

  return response.roles;
};
